import { nextTick } from 'vue';
import useOrdersCreateDataPreparedStore from '@/apps/order/stores/ordersCreate/OrdersCreateDataPreparedStore';
import { useOrdersCreateProgressStore } from '@/apps/order/stores/ordersCreate';

const navigateToCategoryStep = (reject: (reason?: any) => void) => {
  const progressStore = useOrdersCreateProgressStore();
  progressStore.setStepAccessible('category');

  reject(new Error('to:orders-create-category'));
};

const canQueryCustomer = async (): Promise<void> => new Promise((resolve, reject) => {
  nextTick(async () => {
    try {
      const dataPreparedStore = useOrdersCreateDataPreparedStore();
      await dataPreparedStore.fetchCompanySetting();

      if (!dataPreparedStore.companySettings?.allowExistingQuery) {
        navigateToCategoryStep(reject);
      }

      resolve();
    } catch (e) {
      navigateToCategoryStep(reject);
    }
  });
});

export default canQueryCustomer;
